import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useFiltersUpdatedEvent, useSaveSearchModal } from './hooks';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';
import { DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY } from 'shared/constants/microfrontends';
import { usePuidsSelector } from 'shared/hooks/usePuidsSelector';
import { selectIsAgent } from 'shared/selectors/user';
import { IManifestInfo } from 'shared/types/manifestInfo';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const { config } = useApplicationContext();

  const manifestInfo = config.get<IManifestInfo | null>(DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY);

  useFiltersUpdatedEvent();

  const { open, onModalClose, onModalOpen, onSubscribed, subscribeToPush } = useSaveSearchModal();

  const userIsAgent = useSelector(selectIsAgent);

  const adfoxPuids = usePuidsSelector();

  return (
    <>
      {manifestInfo && (
        <Microfrontend
          {...manifestInfo}
          parameters={{
            adfoxPuids,
            professionalSearchAvailable: userIsAgent,
          }}
        />
      )}
      <SaveSearchModalContainer
        isOpen={open}
        onSubscribed={onSubscribed}
        onPushSubscribed={subscribeToPush}
        onOpen={onModalOpen}
        onClose={onModalClose}
      />
    </>
  );
};
